import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    padding: "1rem 1rem 3rem",
    gap: "1.25rem",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",

    "& span": {
      textTransform: "uppercase",
    },
  },
  splash: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    backgroundColor: "#011133",
  },
  avatar: {
    width: "80%",
    height: "auto",
    borderRadius: 0,
  },
});

export default useStyles;
